export var ISO_FORMAT = "YYYY-MM-DD";
export var AUS_FORMAT = "DD/MM/YYYY";
export var ERRORS = {
  incomplete: "Incomplete Date Provided",
  invalid: "Invalid Date Provided"
};